import React from "react";
import PropTypes from "prop-types";
import ReportCard from "Components/reportCard/ReportCard";
import WarningBanner from "Components/warningBanner/WarningBanner";
import { t } from "i18next";
import cx from "classnames";
import s from "./new.scss";
import CustomerSelect from "Components/customerSelect/CustomerSelect";
import TranslatedString from "Components/TranslatedString";
import { useHistory, useLocation } from "react-router-dom";
import QboxmailApi from "@/qboxmailApi";
import { alertError } from "Utils/alerts";

const api = new QboxmailApi({ useCookie: true });

const downloadFile = async (url, callback) => {
  try {
    // Fetch the file
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    // Get the file data
    const data = await response.blob();
    const downloadUrl = window.URL.createObjectURL(data);

    // Create an anchor (<a>) element and set the href to the blob URL
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = url.split("/").pop(); // Optional: provide a default filename here
    document.body.appendChild(a);

    // Click the anchor to trigger the download
    a.click();

    // Clean up the URL and remove the anchor from the DOM
    window.URL.revokeObjectURL(downloadUrl);
    a.remove();

    // Callback if needed
    if (callback) {
      callback();
    }
  } catch (error) {
    console.error("Download failed:", error);
    if (callback) {
      callback(error);
    }
  }
};

const types = [
  {
    title: "report.title.domain",
    type: "domains",
    desc: "report.desc.domain",
  },
  {
    title: "report.title.domain.alias",
    type: "alias_domains",
    desc: "report.desc.domain.alias",
  },
  {
    title: "report.title.domain.limits",
    type: "domains_limits",
    desc: "report.desc.domain.limits",
  },
  {
    title: "report.title.emailAccount",
    type: "email_accounts",
    disabled: process.env.NODE_ENV === "development",
    desc: "report.desc.emailAccount",
  },
  {
    title: "report.title.emailAccount.alias",
    type: "alias_email_accounts",
    desc: "report.desc.emailAccount.alias",
  },
  {
    title: "report.title.archive",
    type: "archive",
    desc: "report.desc.archive",
  },
];

function NewExport(props, context) {
  const isAdmin = context.isLoggedUserAdmin();

  const history = useHistory();
  let location = useLocation();

  const query = new URLSearchParams(location.search);
  const customerToFilter = query.get("customer_code");

  const onCustomerSelection = (val) => {
    let query = "";
    if (val) query = "?customer_code=" + val.value;
    history.push(location.pathname + query);
  };

  const generateReport = async (type) => {
    const resp = await api.generateReport(type, isAdmin && customerToFilter).catch((err) => {
      alertError("Cè stato un errore nella generazione del report. Riprova o contattaci se il problema persiste.");
    });

    if (resp?.file_url) downloadFile(BASE_URL_PUBLIC_ASSETS + resp.file_url);
  };

  return (
    <div className={s.reportList}>
      <header className={s.headerList}>
        <h1 className={cx("sectionTitle", s.titleList)}>
          <TranslatedString>report.list.header.title</TranslatedString>
        </h1>
        <p className={cx("sectionDesc", s.descList)}>
          <TranslatedString>report.list.header.dsc</TranslatedString>
        </p>
      </header>
      <main className={s.contentList}>
        {isAdmin && (
          <header className={s.filters}>
            <CustomerSelect onChange={onCustomerSelection} initialValue={customerToFilter} noLabel />
          </header>
        )}
        <div className={s.table}>
          {types.map((report, i) => (
            <ReportCard
              bannerSlot={report.disabled && <WarningBanner msg={"Not available in development"} />}
              report={report}
              disabled={report.disabled || (isAdmin && !customerToFilter)}
              key={report.title + i}
              onGenerate={generateReport}
            />
          ))}
        </div>
      </main>
    </div>
  );
}

NewExport.contextTypes = {
  isLoggedUserAdmin: PropTypes.func,
};

export default NewExport;
